export default {
  'title': 'light',
  'text-title': '#42446E',
  'text-body': '#666666',
  'text-techs': '#004E93',
  'background1': '#DDEEFF',
  'background2': '#aaccff',
  'cardBackground': '#FFF',
  'shadowOpacity': '0.3',
}